import React from 'react';
import { Section, Card, Countdown } from './Shared';
export const ProductDetails = () => {
  return <>
      {/* Tomos Section */}
      <Section bg="dark" data-id="element-359">
        <div className="text-center mb-12" data-id="element-360">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold mb-4" data-id="element-361">
            📚 6 TOMOS COMPLETOS
          </h2>
          <p className="font-montserrat text-xl text-brand" data-id="element-362">
            Todo listo para aplicar desde hoy
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-363">
          <Card className="bg-[#2A2A2A] border-gray-700 text-base" data-id="element-364">
            <h3 className="font-playfair text-xl font-bold mb-3 text-brand" data-id="element-365">
              📕 TOMO 1<br data-id="element-366" />
              El Arte de Cobrar Caro
            </h3>
            <p className="font-montserrat text-sm text-gray-300 mb-4" data-id="element-367">
              Subí tus precios sin perder clientas y dejá de regalar tu trabajo.
            </p>
            <p className="font-montserrat text-sm italic text-gray-400" data-id="element-368">
              "Por fin cobro lo que vale mi trabajo."
            </p>
          </Card>

          <Card className="bg-[#2A2A2A] border-gray-700 text-base" data-id="element-369">
            <h3 className="font-playfair text-xl font-bold mb-3 text-brand" data-id="element-370">
              📗 TOMO 2<br data-id="element-371" />
              50 Scripts de Reels
            </h3>
            <p className="font-montserrat text-sm text-gray-300 mb-4" data-id="element-372">
              50 guiones listos para copiar, grabar y publicar. Nunca más te
              quedás sin saber qué decir.
            </p>
            <p className="font-montserrat text-sm italic text-gray-400" data-id="element-373">
              "Grabo en 10 minutos y ya tengo contenido."
            </p>
          </Card>

          <Card className="bg-[#2A2A2A] border-gray-700 text-base" data-id="element-374">
            <h3 className="font-playfair text-xl font-bold mb-3 text-brand" data-id="element-375">
              📘 TOMO 3<br data-id="element-376" />
              Historias que Venden
            </h3>
            <p className="font-montserrat text-sm text-gray-300 mb-4" data-id="element-377">
              El sistema para que tus historias de Instagram atraigan consultas
              reales todos los días.
            </p>
            <p className="font-montserrat text-sm italic text-gray-400" data-id="element-378">
              "Mis historias ahora generan turnos."
            </p>
          </Card>

          <Card className="bg-[#2A2A2A] border-gray-700 text-base" data-id="element-379">
            <h3 className="font-playfair text-xl font-bold mb-3 text-brand" data-id="element-380">
              📙 TOMO 4<br data-id="element-381" />
              WhatsApp Closer
            </h3>
            <p className="font-montserrat text-sm text-gray-300 mb-4" data-id="element-382">
              Respondé con seguridad, cerrá más turnos y dejá de perder ventas
              por no saber qué decir.
            </p>
            <p className="font-montserrat text-sm italic text-gray-400" data-id="element-383">
              "Ya no pierdo clientas por WhatsApp."
            </p>
          </Card>

          <Card className="bg-[#2A2A2A] border-gray-700 text-base" data-id="element-384">
            <h3 className="font-playfair text-xl font-bold mb-3 text-brand" data-id="element-385">
              📒 TOMO 5<br data-id="element-386" />
              Máquina de Re-Agendamiento
            </h3>
            <p className="font-montserrat text-sm text-gray-300 mb-4" data-id="element-387">
              Tus clientas vuelven solas. Sin perseguirlas. Sin descuentos. Con
              un protocolo simple.
            </p>
            <p className="font-montserrat text-sm italic text-gray-400" data-id="element-388">
              "Mis clientas vuelven sin que yo las llame."
            </p>
          </Card>

          <Card className="bg-[#2A2A2A] border-gray-700 text-base" data-id="element-389">
            <h3 className="font-playfair text-xl font-bold mb-3 text-brand" data-id="element-390">
              📓 TOMO 6<br data-id="element-391" />
              Planner de Negocio
            </h3>
            <p className="font-montserrat text-sm text-gray-300 mb-4" data-id="element-392">
              Organizá tu negocio como una dueña. Facturación, metas, stock y
              agenda en un solo sistema.
            </p>
            <p className="font-montserrat text-sm italic text-gray-400" data-id="element-393">
              "Por fin tengo claridad de para dónde voy."
            </p>
          </Card>
        </div>

        <div className="max-w-2xl mx-auto bg-[#222] p-8 rounded-xl border border-gray-800" data-id="element-394">
          <ul className="space-y-3 font-montserrat text-base text-gray-200" data-id="element-395">
            <li className="flex items-center gap-3" data-id="element-396">
              <span className="text-brand" data-id="element-397">✅</span> Scripts listos para copiar
              y pegar
            </li>
            <li className="flex items-center gap-3" data-id="element-398">
              <span className="text-brand" data-id="element-399">✅</span> Planillas y checklists
              imprimibles
            </li>
            <li className="flex items-center gap-3" data-id="element-400">
              <span className="text-brand" data-id="element-401">✅</span> Ejemplos reales del rubro
              estética
            </li>
            <li className="flex items-center gap-3" data-id="element-402">
              <span className="text-brand" data-id="element-403">✅</span> PDF editable desde el
              celular
            </li>
            <li className="flex items-center gap-3" data-id="element-404">
              <span className="text-brand" data-id="element-405">✅</span> Listo para usar desde hoy
            </li>
          </ul>
        </div>
      </Section>

      {/* Bonuses Section */}
      <Section bg="mid" data-id="element-406">
        <div className="text-center mb-12" data-id="element-407">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold mb-4 text-dark" data-id="element-408">
            🎁 4 BONOS ESTRATÉGICOS
          </h2>
          <p className="font-montserrat text-xl text-gray-700" data-id="element-409">
            Siempre incluidos. Sin costo extra.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12 max-w-4xl mx-auto" data-id="element-410">
          <Card className="bg-white border-none shadow-md" data-id="element-411">
            <div className="text-sm font-bold text-brand uppercase tracking-wider mb-2" data-id="element-412">
              🎁 BONO 01
            </div>
            <h3 className="font-playfair text-2xl font-bold mb-3 text-dark" data-id="element-413">
              100 Ganchos para Reels
            </h3>
            <p className="font-montserrat text-gray-600 mb-4" data-id="element-414">
              100 primeras líneas listas para que nadie pare de ver tu video.
              Porque si el primer segundo no engancha, nadie ve nada.
            </p>
            <p className="font-montserrat font-bold text-dark" data-id="element-415">
              <span className="line-through text-gray-400 font-normal" data-id="element-416">
                $8.000
              </span>{' '}
              → GRATIS
            </p>
          </Card>

          <Card className="bg-white border-none shadow-md" data-id="element-417">
            <div className="text-sm font-bold text-brand uppercase tracking-wider mb-2" data-id="element-418">
              🎁 BONO 02
            </div>
            <h3 className="font-playfair text-2xl font-bold mb-3 text-dark" data-id="element-419">
              Fotografía con Celular
            </h3>
            <p className="font-montserrat text-gray-600 mb-4" data-id="element-420">
              Fotos de tus trabajos que se ven increíbles con el celular que ya
              tenés. Sin cámara profesional. Sin editor costoso.
            </p>
            <p className="font-montserrat font-bold text-dark" data-id="element-421">
              <span className="line-through text-gray-400 font-normal" data-id="element-422">
                $9.000
              </span>{' '}
              → GRATIS
            </p>
          </Card>

          <Card className="bg-white border-none shadow-md" data-id="element-423">
            <div className="text-sm font-bold text-brand uppercase tracking-wider mb-2" data-id="element-424">
              🎁 BONO 03
            </div>
            <h3 className="font-playfair text-2xl font-bold mb-3 text-dark" data-id="element-425">
              Guía de Promos Flash
            </h3>
            <p className="font-montserrat text-gray-600 mb-4" data-id="element-426">
              30 promos listas para llenar la agenda en 24 horas. Sin bajar tus
              precios. Sin quedar como desesperada.
            </p>
            <p className="font-montserrat font-bold text-dark" data-id="element-427">
              <span className="line-through text-gray-400 font-normal" data-id="element-428">
                $10.000
              </span>{' '}
              → GRATIS
            </p>
          </Card>

          <Card className="bg-white border-none shadow-md" data-id="element-429">
            <div className="text-sm font-bold text-brand uppercase tracking-wider mb-2" data-id="element-430">
              🎁 BONO 04
            </div>
            <h3 className="font-playfair text-2xl font-bold mb-3 text-dark" data-id="element-431">
              Plantillas de Canva
            </h3>
            <p className="font-montserrat text-gray-600 mb-4" data-id="element-432">
              Tu Instagram empieza a verse como un negocio de verdad. Paletas,
              tipografías y los 10 diseños que toda profesional necesita.
            </p>
            <p className="font-montserrat font-bold text-dark" data-id="element-433">
              <span className="line-through text-gray-400 font-normal" data-id="element-434">
                $9.000
              </span>{' '}
              → GRATIS
            </p>
          </Card>
        </div>

        <div className="bg-dark text-base text-center py-6 px-4 rounded-xl max-w-3xl mx-auto shadow-lg" data-id="element-435">
          <p className="font-montserrat text-lg md:text-xl font-bold" data-id="element-436">
            Valor total de los bonos:{' '}
            <span className="line-through text-gray-400 font-normal" data-id="element-437">
              $36.000
            </span>{' '}
            <span className="text-brand" data-id="element-438">→ GRATIS con tu Megakit</span>
          </p>
        </div>
      </Section>

      {/* Urgency Section */}
      <Section bg="dark" className="text-center" data-id="element-439">
        <h2 className="font-playfair text-3xl md:text-5xl font-bold mb-6" data-id="element-440">
          ⏰ PRECIO DE LANZAMIENTO
        </h2>
        <p className="font-montserrat text-lg text-gray-300 max-w-2xl mx-auto mb-10" data-id="element-441">
          Este precio existe solo durante el lanzamiento. Cuando cierre, sube
          $8.000 ARS y no vuelve.
        </p>

        <div className="bg-[#222] inline-block py-6 px-8 md:px-12 rounded-2xl border border-gray-800 mb-6 shadow-2xl" data-id="element-442">
          <Countdown data-id="element-443" />
        </div>

        <p className="font-montserrat text-brand font-bold mb-10" data-id="element-444">
          ⚠️ Después sube $8.000 ARS. No vuelve.
        </p>

        <div className="max-w-md mx-auto bg-[#2A2A2A] p-6 rounded-xl border border-gray-700" data-id="element-445">
          <p className="font-montserrat text-sm font-bold mb-3 flex items-center justify-between" data-id="element-446">
            <span data-id="element-447">🔥 Cupos al precio de lanzamiento</span>
            <span className="text-brand" data-id="element-448">Quedan pocos</span>
          </p>
          <div className="w-full bg-gray-800 rounded-full h-4 mb-3 overflow-hidden" data-id="element-449">
            <div className="bg-brand h-4 rounded-full" style={{
            width: '71%'
          }} data-id="element-450"></div>
          </div>
          <p className="font-montserrat text-xs text-gray-400 text-right" data-id="element-451">
            71% de los cupos ya tomados
          </p>
        </div>
      </Section>
    </>;
};